<template>
  <div id="users">
    <!-- Users Filter -->
    <b-form-input
      type="text"
      ref="filterUsers"
      placeholder="Filter Organizers"
      v-model="filter">
    </b-form-input>
    <!-- / Users Filter -->

    <!-- Users Table -->
    <b-table
      striped
      hover
      selectable
      small
      show-empty
      stacked="lg"
      select-mode="single"
      sort-by="name"
      @row-selected="goToUser"
      :items="filteredUsers"
      :fields="fields"
      empty-text="No Users to show.">
    </b-table>
    <!-- / Users Table -->

    <!-- Create Users Button -->
    <b-button
      class="corner-button shadow"
      type="button"
      variant="success"
      @click="$router.push({ name: 'organizer', params: { userID: 'new' } })">
      <font-awesome-icon icon="plus"></font-awesome-icon> Create New User
    </b-button>
    <!-- / Create Users Button -->
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/app-mixin';
import DataSvc from '../services/data';

export default {
  name: 'users',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      filter: '',
      users: [],
      fields: [
        {
          key: 'last_name',
          sortable: true,
        },
        {
          key: 'first_name',
          sortable: true,
        },
        {
          key: 'organization',
          label: 'Organization',
          sortable: true,
        },
        {
          key: 'email',
          sortable: true,
        },
        {
          key: 'primary_phone',
          label: 'Phone',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    filteredUsers() {
      return _.filter(
        this.users,
        (user) => {
          const f = this.filter.toLowerCase();
          const matchesFirstName = user.first_name.toLowerCase().includes(f);
          const matchesLastName = user.last_name.toLowerCase().includes(f);
          const matchesOrganization = user.organization && user.organization.toLowerCase().includes(f);
          const matchesEmail = user.email && user.email.toLowerCase().includes(f);
          const matchesPhoneNumber = user.primary_phone && user.primary_phone.toLowerCase().includes(f);

          return matchesFirstName
            || matchesLastName
            || matchesOrganization
            || matchesEmail
            || matchesPhoneNumber;
        },
      );
    },
  },
  methods: {
    goToUser(selected) {
      const [o] = selected;
      this.$router.push({
        name: 'organizer',
        params: { userID: o.id },
      });
    },
    getOrg(id) {
      const org = _.find(this.organizations, { id }) || {};
      return org.name;
    },
  },
  created() {
    const initUsers = () => {
      DataSvc.getUsers()
        .then((users) => {
          this.users = _.filter(
            users,
            user => user.permissions.includes('organizers'),
          );

          _.each(this.users, (user) => {
            let org = _.find(this.organizations, { id: user.admin_organization_id });

            if (org) {
              org = org.name;
            }

            user.organization = org;
          });
        });
    };

    this.showGlobalLoader('Loading users...');
    this.initPromise
      .then(initUsers)
      .finally(this.hideGlobalLoader);
  },
};
</script>

<style lang="scss"></style>
